export default __webpack_public_path__ + "static/media/movie-ticket1.c14f6be4.svg";